import { TenantTheme } from '@core/multi-tenancy/models/tenant-theme.model';
import { TenantName } from '@core/multi-tenancy/constants/tenant-names.enum';

export const tenantThemes: { [k: string]: TenantTheme } = {
    [TenantName.stranaidea]: { primaryColor: '#EF7B00', accentColor: '#004379', logoName: 'logo_horizontal.png', fontStyleClass: 'font-arial' },
};
